<template>
    <div class="page-container">
        <div class="purchase-status-block">
            <div class="status-text">
                <template v-if="pageData.status == 5 || pageData.status == 7">
                    <div class="status">正在捡货中</div>
                    <div class="status-aside">您的提货商品已经整装待发,等待揽件中</div>
                </template>
                <template v-else-if="pageData.status == 1">
                    <div class="status">待处理订单</div>
                    <div class="status-aside">您可继续提交订单,或者取消订单重新提货</div>
                </template>
                <template v-else-if="pageData.status == 6">
                    <div class="status">商品已发货</div>
                    <div class="status-aside">您的提货商品正马不停蹄的奔向收货地</div>
                </template>
                <template v-else-if="pageData.status == 10">
                    <div class="status">提货商品签收成功</div>
                    <div class="status-aside">该笔提货单已经交易成功</div>
                </template>
                <template v-else-if="pageData.status == 9">
                    <div class="status">订单已经取消</div>
                    <div class="status-aside">您的提货订单取消了,有需求可重新去提货哦</div>
                </template>
            </div>
            <img src="../../assets/icon-purchase-succ.png" class="status-pic">
        </div>
        <div class="page-bottom">
            <div class="goods-bock" v-for="(item,index) in pageData.inventoryList" :key="index">
                <div class="goods-info-block">
                    <img :src="item.picUrl" class="goods-pic">
                    <div class="goods-detail">
                        <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                        <div class="goods-sku">{{item.unit == '瓶' ? '单瓶' : '整箱(6瓶)'}}</div>
                        <div class="caigou-price">采购价：¥{{item.price}}</div>
                    </div>
                </div>
                <div class="price-count">
                    <div class="goods-price">¥{{item.price * item.num}}</div>
                    <div class="goods-count">x{{item.num}}({{item.unit}})</div>
                </div>
            </div>
            <!-- 订单信息 -->
            <div class="order-block">
                <div class="block-title">提货单信息</div>
                <div class="info-block">
                    <div class="info-item">
                        <span>提货订单号</span>
                        <span>{{pageData.orderNo}}</span>
                    </div>
                    <div class="info-item">
                        <span>下单时间</span>
                        <span>{{pageData.createTime | formatCreatetime}}</span>
                    </div>
                    <div class="info-item">
                        <span>销售总价</span>
                        <span>{{pageData.agentAmount == 0 ? '/' : pageData.agentAmount}}</span>
                    </div>
                    <!-- <div class="info-item">
                        <span>提货总价</span>
                        <span>¥{{pageData.agentAmount}}</span>
                    </div> -->
                    <!-- <div class="info-item">
                        <span>是否开发票</span>
                        <span>是</span>
                    </div> -->
                    <div class="info-item">
                        <span>备注</span>
                        <span>{{pageData.message == '' ? '/' : pageData.message}}</span>
                    </div>
                    <div class="info-item" style="align-items:flex-start;">
                        <span>收货人地址</span>
                        <span>
                            <i>{{`${pageData.name} ${pageData.mobile}`}}</i>
                            <i>{{`${pageData.address}`}}</i>
                        </span>
                    </div>
                </div>
            </div>
            <!-- 物流信息 -->
            <div class="transfer-info" v-if="pageData.expressNo">
                <div class="block-title">物流信息</div>
                <div class="transfer-number"><span>物流单号：{{pageData.expressNo}}</span> <span class="btn-copy" v-clipboard:copy="pageData.expressNo" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span></div>
                <!-- <div class="transfer-number"><span>发货时间：2020-10-10</span></div> -->
            </div>

            <!-- 底部按钮 -->
            <!-- <div class="btn-line">
                <div class="btn-cancel">取消订单</div>
                <div class="btn-confirm">确认提货</div>
            </div> -->
        </div>
        <!-- 底部按钮行 -->
        <div class="btn-line" v-show="pageData.status == 6">
            <div class="btn-item" @click.stop="goStrack(pageData.orderId)">查看物流</div>
        </div>
    </div>

</template>
<script>
import { Notify,Toast } from 'vant'
import $http from '@/lib/request'
import config from '@/config'

export default {
    data(){
        return {
            pageData:{},
        }
    },
    components:{
        [Notify.name]:Notify,
        [Toast.name]:Toast
    },
    methods:{
        copySucc(){
            Notify({ type: 'success', message: '复制成功' });
        },
        copyFail(){
            Notify({ type: 'danger', message: '复制失败' });
        },
        goStrack(oid){
            this.$router.push({
                name:'order-tracking',
                params:{
                    orderId:oid
                }
            });
        }
    },
    activated(){
        $http({
            method:'post',
            data:{
                orderId:this.$route.params.orderId
            },
            url:config.api.pickupDetail
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
            }else{
                Toast(res.errmsg);
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.page-container{
    min-height:100vh;
    background:#fafafa;
    box-sizing: border-box;
    padding-bottom: 60px;
    .purchase-status-block{
        padding:20px 36px;
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .status-text{
            width:230px;
            color:#fff;
            .status{
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 4px;
            }
            .status-aside{
                font-size: 12px;
                line-height: 16px;
            }
        }
        .status-pic{
            width:60px;
            height:60px;
        }
    }
    .page-bottom{
        padding:10px;
        padding-bottom: 50px;
        .goods-bock{
            background:#fff;
            padding:15px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 10px;
            .goods-info-block{
                width:220px;
                display: flex;
                justify-content: flex-start;
                .goods-pic{
                    width:80px;
                    height:80px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-detail{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .goods-name{
                        width:180px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color:#000;
                        line-height: 20px;
                        font-size: 14px;
                    }
                    .goods-sku{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                    .caigou-price{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
            .price-count{
                width: 80px;
                text-align: right;
                .goods-price{
                    color:#333;
                    line-height: 20px;
                    margin-bottom: 10px;
                    font-size: 14px;
                }
                .goods-count{
                    color:#3088F5;
                    line-height: 18px;
                    font-size: 12px;
                }
            }
        }
        .order-block{
            background:#fff;
            margin-bottom: 10px;
            .block-title{
                padding:14px;
                color:#333;
                line-height: 20px;
                font-size: 15px;
                padding-bottom: 0;
            }
            .info-block{
                padding:15px;
                .info-item{
                    color:#666;
                    line-height: 18px;
                    padding:4px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 13px;
                    &>span{
                        &:last-child{
                            text-align: right;
                            color:#333;
                            i{
                                display: block;
                                font-style: normal;
                            }
                        }
                    }
                }
            }
        }
        .transfer-info{
            background:#fff;
            .block-title{
                padding:15px;
                color:#333;
                line-height: 20px;
                font-size: 14px;
                padding-bottom: 0;
            }
            .transfer-number{
                padding:15px;
                color:#666;
                line-height: 18px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 13px;
                .btn-copy{
                    color:#E12323;
                }
            }
        }
        .btn-line{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: 25px;
            .btn-cancel{
                width: 90px;
                height: 30px;
                line-height: 30px;
                background: #FFFFFF;
                border-radius: 26px;
                border: 1px solid #DCDADA;
                text-align: center;
                font-size: 14px;
                color:#333;
            }
            .btn-confirm{
                width: 90px;
                height: 30px;
                line-height: 30px;
                background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
                border-radius: 26px;
                color:#fff;
                text-align: center;
                font-size: 14px;
                margin-left: 20px;
            }
        }
    }
    .btn-line{
        padding: 10px;
        background:#fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: fixed;
        left:0;
        bottom:0;
        width:100%;
        box-sizing: border-box;
        .btn-item{
            width: 90px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: #FFFFFF;
            border-radius: 26px;
            border: 1px solid #DCDADA;
            color:#333;
            font-size: 14px;
        }
    }
}
</style>